export const getOffsetSize = function (Node: any, offset?: any): any {
  if (!offset) {
    offset = {
      x: 0,
      y: 0,
    };
  }
  if (Node === document.body) return offset;
  offset.x += Node.offsetLeft;
  offset.y += Node.offsetTop;
  return getOffsetSize(Node.offsetParent, offset);
};
